import React, { useState } from 'react';
import { Layout } from 'antd';

import './utils/fontRegistry'; // 确保字体在应用启动时注册
import './App.scss';
import FontLoader from './pages/FontLoader/FontLoader';
import CreatePdf from './pages/CreatePdf/CreatePdf';
const { Content, Sider } = Layout;
function App() {  
  // 添加字体加载状态
  const [fontsLoaded, setFontsLoaded] = useState(false);
  // 字体加载完成回调
  const handleFontsLoaded = () => {
    console.log('字体加载完成');
    setFontsLoaded(true);
  };

  return (
    <Layout style={{ height: '100vh' }}>
      {
        fontsLoaded ? 
        <CreatePdf /> :
        <FontLoader onComplete={handleFontsLoaded} />
      }
    </Layout>
  );
}

export default App;
